/* global FB */
export const share2FB = (title, image, callback) => {
  const options = {
    method: 'share_open_graph',
    action_type: 'og.likes',
    action_properties: JSON.stringify({
      object: {
        'og:url': 'https://program-helper.github.io',
        'og:title': title,
        'og:description': '為您尋找最適合的學分學程！點擊查看更多！',
        'og:image': image,
      }
    })
  };
  FB.ui(options, callback);
}